enum ColorOption {
  Maroon = "Maroon",
  Red = "Red",
  Orange = "Orange",
  Yellow = "Yellow",
  Olive = "Olive",
  Green = "Green",
  Purple = "Purple",
  Fuchsia = "Fuchsia",
  Lime = "Lime",
  Teal = "Teal",
  Aqua = "Aqua",
  Blue = "Blue",
  Gray = "Gray",
  Silver = "Silver",
  White = "White",
}

export default ColorOption;
